/**
 * Auth utility functions extracted from AuthService
 * These methods handle authentication cleanup and logout operations
 */

import { historyStorage } from '@/utils/historyStorage'

/**
 * Clears all local storage data and redirects to error page
 * @param {object} authInstance - The auth service instance containing tokenRefreshTimer
 */
export function clearDataAndRedirect(authInstance = null) {
    console.log('🗑️ Clearing local storage and redirecting to error page...')

    // Clear timers if provided
    if (authInstance?.tokenRefreshTimer) {
        clearTimeout(authInstance.tokenRefreshTimer)
    }
    if (authInstance?.sessionCheckInterval) {
        clearInterval(authInstance.sessionCheckInterval)
    }

    // Reset timer references
    if (authInstance) {
        Object.assign(authInstance, {
            tokenRefreshTimer: null,
            sessionCheckInterval: null,
        })
    }

    // Clear all localStorage data
    localStorage.clear()

    // Reset auth instance properties if provided
    if (authInstance) {
        Object.assign(authInstance, {
            keycloak: null,
            isInitialized: false,
        })
    }

    // Redirect to error page if not already there
    if (window.location.pathname !== '/error-access') {
        window.location.href = '/error-access'
    }
}

/**
 * Performs logout operation with proper cleanup
 * @param {object} keycloak - Keycloak instance
 * @param {number} tokenRefreshTimer - Token refresh timer reference
 * @returns {Promise<void>}
 */
export async function logout(keycloak = null, tokenRefreshTimer = null) {
    try {
        // Clear token refresh timer
        if (tokenRefreshTimer) {
            clearTimeout(tokenRefreshTimer)
        }

        historyStorage.clear()

        // Perform Keycloak logout if authenticated
        if (keycloak && keycloak.authenticated) {
            const logoutOptions = { redirectUri: window.location.origin }
            await keycloak.logout(logoutOptions)
        } else {
            // Fallback: clear storage and reload
            localStorage.clear()
            window.location.reload()
        }
    } catch (error) {
        console.error('Keycloak logout error:', error)
        // Fallback on error: clear storage and reload
        localStorage.clear()
        window.location.reload()
    }
}
